import { useAuth } from '@shared/auth';
import { useDisclosure } from '@shared/hooks';
import { createContext, useEffect, useMemo, useState } from 'react';

import { useAppMenu, useGetSidebarItems } from '../../hooks';

import type { SidebarContextInterface, SidebarProviderProps } from './types';

const SidebarContext = createContext<SidebarContextInterface | undefined>(undefined);

function SidebarProvider(props: Readonly<SidebarProviderProps>) {
  const { children } = props;

  const appShell = useGetSidebarItems();
  const { appMenu } = useAppMenu({ appShell });
  const [isOpen, { open, close, toggle }] = useDisclosure(true);
  const [isSecondarySidebarMounted, setIsSecondarySidebarMounted] = useState(false);
  const { userProfile } = useAuth();

  const user = {
    displayName: `${userProfile?.firstName ?? ''} ${userProfile?.lastName ?? ''}`,
  };

  useEffect(() => {
    if (isSecondarySidebarMounted) {
      close();
    } else {
      open();
    }
    // run effects only when secondary sidebar status is changed
  }, [isSecondarySidebarMounted]);

  const sideBarContextValue = useMemo(
    () => ({
      isOpen,
      open,
      close,
      toggle,
      isSecondarySidebarMounted,
      setIsSecondarySidebarMounted,
      appMenu,
      user,
    }),
    [
      isOpen,
      open,
      close,
      toggle,
      isSecondarySidebarMounted,
      setIsSecondarySidebarMounted,
      appMenu,
      user,
    ],
  );

  return <SidebarContext.Provider value={sideBarContextValue}>{children}</SidebarContext.Provider>;
}

export { SidebarContext, SidebarProvider };
